var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocumentText = function SvgDocumentText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31 6.31C4.48 8.143 3.5 11.149 3.5 16v12c0 4.852.98 7.858 2.81 9.69 1.832 1.83 4.838 2.81 9.69 2.81h12c4.852 0 7.858-.98 9.69-2.81 1.83-1.832 2.81-4.838 2.81-9.69V18a1.5 1.5 0 0 1 3 0v10c0 5.148-1.02 9.142-3.69 11.81-2.668 2.67-6.662 3.69-11.81 3.69H16c-5.148 0-9.142-1.02-11.81-3.69C1.52 37.143.5 33.149.5 28V16c0-5.148 1.02-9.142 3.69-11.81C6.857 1.52 10.851.5 16 .5h10a1.5 1.5 0 0 1 0 3H16c-4.852 0-7.858.98-9.69 2.81Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.426.614a1.5 1.5 0 0 1 1.635.325l16 16A1.5 1.5 0 0 1 42 19.5h-8c-3.083 0-5.616-.494-7.31-2.19-1.696-1.694-2.19-4.227-2.19-7.31V2a1.5 1.5 0 0 1 .926-1.386ZM27.5 5.621V10c0 2.917.506 4.384 1.31 5.19.806.805 2.273 1.31 5.19 1.31h4.379L27.5 5.621ZM10.5 24a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 0 3H12a1.5 1.5 0 0 1-1.5-1.5ZM10.5 32a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 0 3h-8a1.5 1.5 0 0 1-1.5-1.5Z",
    fill: "#123862"
  })));
};
export default SvgDocumentText;